import AccountLayout from "./layouts/account-layout";

export default {
  path: "account",
  meta: { noNeedAuth: true },
  component: AccountLayout
};
